import { Action } from '@ngrx/store';
import { LoginRequest, LoginResponse, ForgotPasswordRequest } from './auth.models';
import { Preferences, NotificationsSettings } from '../../global/interfaces';
import { ReportsCheckboxes } from '../reports/reports.models';
import { User } from '../administration/user/user.models';

export enum ActionTypes {
  LOGIN = '[Auth] Attempt Login Action',
  LOGIN_SUCCESS = '[Auth] Attempt Login Success Action',
  LOGIN_FAILED = '[Auth] Attempt Login Failed Action',

  GET_USER = '[Auth] Attempt Get User Info Action',
  GET_USER_SUCCESS = '[Auth] Attempt Get User Info Success Action',
  GET_USER_FAILED = '[Auth] Attempt Get User Info Failed Action',

  UPDATE_USER_PREFERENCES = '[Auth] Update User Preferences',
  UPDATE_USER_NOTIFICATIONS = '[Auth] Update User Notifications Settings',
  UPDATE_USER_REPORTS = '[Auth] Update User Reports',

  REFRESH_TOKEN = '[Auth] Refresh Login User Token Action',
  REFRESH_TOKEN_SUCCESS = '[Auth] Refresh Login User Token Success Action',
  REFRESH_TOKEN_FAILED = '[Auth] Refresh Login User Token Failed Action',

  LOGOUT = '[Auth] Logout Action',
  LOG_LOGOUT = '[Auth] lOG Logout Action',
  LOG_LOGOUT_SUCCESS = '[Auth] lOG Logout Success Action',

  CLEAR_STATE = '[Auth] Clear Login State Action',

  ACCEPT_TERMS_AND_CONDITIONS = '[Auth] Accept Terms and Conditions Action',
  ACCEPT_TERMS_AND_CONDITIONS_SUCCESS = '[Auth] Accept Terms and Conditions Success Action',

  LOAD_USER_NOTIFICATIONS = '[User Notification] Load User Notification Action',
  LOAD_USER_NOTIFICATIONS_SUCCESS = '[User Notification] Load User Notification Success Action',
  LOAD_USER_NOTIFICATIONS_FAILED = '[User Notification] Load User Notification Failed Action',

  MARK_USER_NOTIFICATION = '[User Notification] Mark User Notification Action',
  MARK_USER_NOTIFICATION_SUCCESS = '[User Notification] Mark User Notification Success Action',
  MARK_USER_NOTIFICATION_FAILED = '[User Notification] Mark User Notification Failed Action',

  UPDATE_USER_PROFILE_IMAGE = '[User Profile] Update User Profile Image Action',
  UPDATE_USER_PROFILE_IMAGE_SUCCESS = '[User Profile] Update User Profile Image Success Action',
  UPDATE_USER_PROFILE_IMAGE_FAILED = '[User Profile] Update User Profile Image Failed Action',

  REMOVE_LOGED_USER_PROFILE_IMAGE = '[User Profile] Remove User Profile Image Action',
  REMOVE_LOGED_USER_PROFILE_IMAGE_SUCCESS = '[User Profile] Remove User Profile Image Action',
  REMOVE_LOGED_USER_PROFILE_IMAGE_FAILED = '[User Profile] Remove User Profile Image Action',
  FORGOT_PASSWORD = '[Auth] Attempt Forgot Password Action',
  FORGOT_PASSWORD_SUCCESS = '[Auth] Attempt Forgot Password Success Action',
  FORGOT_PASSWORD_FAILED = '[Auth] Attempt Forgot Password Failed Action',
  FORGOT_PASSWORD_RESET_FORM = '[Auth] Attempt Forgot Password Reset Form Action'
}

export class LoginAction implements Action {
  readonly type = ActionTypes.LOGIN;

  public constructor(public payload: LoginRequest) {
  }
}

export class LoginSuccessAction implements Action {
  readonly type = ActionTypes.LOGIN_SUCCESS;

  public constructor(public payload: LoginResponse) {
  }
}

export class LoginFailedAction implements Action {
  readonly type = ActionTypes.LOGIN_FAILED;

  public constructor(public payload: any) {
  }
}

export class GetUserAction implements Action {
  readonly type = ActionTypes.GET_USER;
}

export class GetUserSuccessAction implements Action {
  readonly type = ActionTypes.GET_USER_SUCCESS;

  public constructor(public payload: User) {
  }
}

export class GetUserFailedAction implements Action {
  readonly type = ActionTypes.GET_USER_FAILED;

  public constructor(public payload: any) {
  }
}

export class UpdateUserPreferencesAction implements Action {
  readonly type = ActionTypes.UPDATE_USER_PREFERENCES;

  public constructor(public payload: Preferences) {
  }
}

export class UpdateUserNotificationsSettingsAction implements Action {
  readonly type = ActionTypes.UPDATE_USER_NOTIFICATIONS;

  public constructor(public payload: NotificationsSettings) {
  }
}

export class UpdateUserReportsAction implements Action {
  readonly type = ActionTypes.UPDATE_USER_REPORTS;

  public constructor(public payload: ReportsCheckboxes) {
  }
}

export class UpdateUserProfileImageAction implements Action {
  readonly type = ActionTypes.UPDATE_USER_PROFILE_IMAGE;

  public constructor(public payload: any) {
  }
}

export class UpdateUserProfileImageSuccessAction implements Action {
  readonly type = ActionTypes.UPDATE_USER_PROFILE_IMAGE_SUCCESS;

  public constructor(public payload: any) {
  }
}

export class UpdateUserProfileImageFailedAction implements Action {
  readonly type = ActionTypes.UPDATE_USER_PROFILE_IMAGE_FAILED;

  public constructor(public payload: any) {
  }
}

export class RefreshTokenAction implements Action {
  readonly type = ActionTypes.REFRESH_TOKEN;
}

export class RefreshTokenSuccessAction implements Action {
  readonly type = ActionTypes.REFRESH_TOKEN_SUCCESS;

  public constructor(public payload: LoginResponse) {
  }
}

export class RefreshTokenFailedAction implements Action {
  readonly type = ActionTypes.REFRESH_TOKEN_FAILED;

  public constructor(public payload: any) {
  }
}

export class LogoutAction implements Action {
  readonly type = ActionTypes.LOGOUT;

  public constructor(public payload?: { message?: string; title?: string; error?: boolean }) {
  }
}

export class LogLogoutAction implements Action {
  readonly type = ActionTypes.LOG_LOGOUT;
}

export class LogLogoutsuccessAction implements Action {
  readonly type = ActionTypes.LOG_LOGOUT_SUCCESS;
  public constructor(public payload: LoginResponse) {
  }
}

export class ClearLoginStateAction implements Action {
  readonly type = ActionTypes.CLEAR_STATE;
}

export class AcceptTermsAndConditionsAction implements Action {
  readonly type = ActionTypes.ACCEPT_TERMS_AND_CONDITIONS;
}

export class AcceptTermsAndConditionsSuccessAction implements Action {
  readonly type = ActionTypes.ACCEPT_TERMS_AND_CONDITIONS_SUCCESS;
}

export class LoadUserNotificationsAction implements Action {
  public readonly type = ActionTypes.LOAD_USER_NOTIFICATIONS;
}

export class LoadUserNotificationsSuccessAction implements Action {
  public readonly type = ActionTypes.LOAD_USER_NOTIFICATIONS_SUCCESS;
  public constructor(public payload: any) { }
}

export class LoadUserNotificationsFailedAction implements Action {
  public readonly type = ActionTypes.LOAD_USER_NOTIFICATIONS_FAILED;
  public constructor(public payload: any) { }
}

export class MarkUserNotificationAction implements Action {
  public readonly type = ActionTypes.MARK_USER_NOTIFICATION;
  public constructor(public payload: any) { }
}

export class MarkUserNotificationSuccessAction implements Action {
  public readonly type = ActionTypes.MARK_USER_NOTIFICATION_SUCCESS;
  public constructor(public payload: any) { }
}

export class MarkUserNotificationFailedAction implements Action {
  public readonly type = ActionTypes.MARK_USER_NOTIFICATION_FAILED;
  public constructor(public payload: any) { }
}

export class RemoveLogedUserProfileImageAction implements Action {
  readonly type = ActionTypes.REMOVE_LOGED_USER_PROFILE_IMAGE;

  public constructor(public payload: any) {
  }
}

export class RemoveLogedUserProfileImageSuccessAction implements Action {
  readonly type = ActionTypes.REMOVE_LOGED_USER_PROFILE_IMAGE_SUCCESS;

  public constructor() {
  }
}

export class RemoveLogedUserProfileImageFailedAction implements Action {
  readonly type = ActionTypes.REMOVE_LOGED_USER_PROFILE_IMAGE_FAILED;

  public constructor(public payload: any) {
  }
}

export class ForgotPasswordAction implements Action {
  readonly type = ActionTypes.FORGOT_PASSWORD;
  public constructor(public payload: ForgotPasswordRequest) {
  }
}

export class ForgotPasswordSuccessAction implements Action {
  readonly type = ActionTypes.FORGOT_PASSWORD_SUCCESS;
  public constructor(public payload: any) {
  }
}

export class ForgotPasswordFailedAction implements Action {
  readonly type = ActionTypes.FORGOT_PASSWORD_FAILED;
  public constructor(public payload: any) {
  }
}

export class ForgotPasswordResetFormAction implements Action {
  readonly type = ActionTypes.FORGOT_PASSWORD_RESET_FORM;
  public constructor() {
  }

}
export type Actions =
  LoginAction |
  LoginSuccessAction |
  LoginFailedAction |
  GetUserAction |
  GetUserSuccessAction |
  GetUserFailedAction |
  UpdateUserPreferencesAction |
  UpdateUserNotificationsSettingsAction |
  UpdateUserReportsAction |
  RefreshTokenAction |
  RefreshTokenSuccessAction |
  RefreshTokenFailedAction |
  LogoutAction |
  LogLogoutsuccessAction |
  ClearLoginStateAction |
  AcceptTermsAndConditionsAction |
  AcceptTermsAndConditionsSuccessAction |
  LoadUserNotificationsAction |
  LoadUserNotificationsSuccessAction |
  LoadUserNotificationsFailedAction |
  MarkUserNotificationAction |
  MarkUserNotificationSuccessAction |
  MarkUserNotificationFailedAction |
  UpdateUserProfileImageAction |
  UpdateUserProfileImageSuccessAction |
  UpdateUserProfileImageFailedAction |
  RemoveLogedUserProfileImageAction |
  RemoveLogedUserProfileImageSuccessAction |
  RemoveLogedUserProfileImageFailedAction |
  ForgotPasswordAction |
  ForgotPasswordSuccessAction |
  ForgotPasswordFailedAction |
  ForgotPasswordResetFormAction;

